export const toS3SafeName = (name: string) => name.split(" ").join("~");

export const fromS3SafeName = (name: string) => name.split("~").join(" ");
